import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { SEARCH_REQUEST, SEARCH_MODULE_NAMESPACE, SEARCH_AUTOCOMPLETE } from '../../../../store/search';
import { namespace } from 'vuex-class';
import { SearchEntities } from '../../../../common/enums';
import { TICKET_MODULE_NAMESPACE, TICKET_ADD_PARTICIPANTS } from '../../../../store/ticket';

const SearchStore = namespace(SEARCH_MODULE_NAMESPACE)
const TicketStore = namespace(TICKET_MODULE_NAMESPACE)

@Component
class TicketSideBarAddParticipantModal extends Vue {

  _clearTimeout: any;

  @Prop({ default: false, type: [Boolean] })
  visible: boolean;
  @Prop({ default: false, type: [Object] })
  channel: any;

  dtRules: any;
  dtMembers: any;
  dtIsLoading: boolean;
  dtParticipants: any[]
  dtParticipantsSource: any[];
  dtAddError: boolean;
  dtError: any;

  get coVisible(): boolean {
    return this.visible;
  }
  set coVisible(value: boolean) {
    this.$emit('update:visible', value)
  }

  get lblSetting() {
    return {
      ...require('@/locales/validation-messages').default,
      ...require('@/locales/ticket').default
    };

  }
  /**
   *
   */
  constructor() {
    super();
    this.dtMembers = [];
    this.dtAddError = false;
    this.dtError = null;
    this.dtParticipants = [];
    this.dtParticipantsSource = [];
    this.dtIsLoading = false;
    this.dtRules = {}
  }

  @SearchStore.Getter declarants: any[]



  @TicketStore.Action(TICKET_ADD_PARTICIPANTS)
  storeAddParticipants: (option: { ticketId: string, channelId: string, data: any[] }) => Promise<any>

  get coParticipant(): any[] {
    return this.declarants;
  }
  mounted() {
    this.dtRules = {
      independentContractor: [(v) => !!v && v.length > 0 || this.$t(this.lblSetting.groupMemberRequired)],
    }
    this.dtParticipantsSource = JSON.parse(JSON.stringify(this.declarants))
  }
  handleSave() {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      if (this.dtParticipants.length === 0) {
        this.coVisible = false;
        return;
      }

      this.dtIsLoading = true;
      this.storeAddParticipants({ ticketId: this.$route.params.id, channelId: this.$route.params.cid, data: this.dtParticipants })
        .then(res => {
          this.dtIsLoading = false;
          this.coVisible = false;
          this.dtAddError = false;
          this.dtError = null
          this.dtParticipants = [];
        })
        .catch(err => {
          this.dtIsLoading = false;
          this.dtError = err;
          this.dtAddError = true;
        })
    }, 300);
  }
  handleOnClose() {
    this.resetValues();
  }

  resetValues() {
    this.dtParticipants = [];
    this.dtParticipantsSource = [];
  }
  handleCloseError() {
    this.dtError = null;
    this.dtAddError = false;
  }
  beforeDestroy() {
    this.resetValues()
  }
}

export default TicketSideBarAddParticipantModal;


// WEBPACK FOOTER //
// ./src/containers/ticket/components/ticket-sidebar-modal-add-member/index.ts